import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, Grid, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { HiOutlineTrash } from "react-icons/hi";

import Button, { Color } from "../../../../../../../../components/Form/Button";

import useStyles from "./styles";

interface Props {
  open: boolean;
  closeModal: () => void;
  undoChanges: () => void;
}

export const ConfirmCancelModal = ({ open, undoChanges, closeModal }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={closeModal}>
      <div className={classes.paper}>
        <div className={classes.modalBody}>
          <header className={classes.modalHeader}>
            <div className="d-flex flex-row align-items-center">
              <span className={classes.warningIcon}>
                <HiOutlineTrash />
              </span>
              <p className={classes.modalHeaderTitle}>{t("discardChanges")}</p>
            </div>
            <IconButton onClick={closeModal}>
              <Close />
            </IconButton>
          </header>
          <section className={classes.modalSection}>
            <p className={classes.text}>{t("areYouSureYouWantToDiscardAllChanges")}</p>
            <p className={classes.warningText}>{t("thisActionIsPermanentAndCannotBeUndone")}</p>
          </section>
          <section className={classes.modalFooter}>
            <Grid
              container
              direction="row"
              alignItems="flex-start"
              justifyContent="flex-end"
              spacing={2}
            >
              <Button onClick={closeModal}>{t("cancel")}</Button>
              <Button
                customColor={Color.ERROR}
                onClick={() => {
                  undoChanges();
                  closeModal();
                }}
              >
                {t("discard")}
              </Button>
            </Grid>
          </section>
        </div>
      </div>
    </Modal>
  );
};
